import loadImage from './loadImage.js';
import preloadImages from './preloadImages.js';
export default {
  loadImage,
  preloadImages
};


// WEBPACK FOOTER //
// ./node_modules/swiper/core/images/index.js